import React from 'react'

export const InformClimateChange = () => {
  return <img style={{ width: 40, border: 'none' }} src="/img/risk-indices/climate-change.png" alt="Worldfavor Logo" />
}

export default InformClimateChange
